const EmployeeTableActions = ({
  setShowUploadPopup,
  handleDownload,
  handleView,
  handleEdit,
  handleDelete,
}) => {
  return (
    <div className="flex gap-4 justify-end p-2.5 bg-white">
      <button
        className="text-xs font-semibold text-primary-hrms bg-white border-0 cursor-pointer"
        onClick={() => setShowUploadPopup(true)}
      >
        <span>
          <i className="ri-upload-line"></i> Upload
        </span>
      </button>

      <button
        className="text-xs font-semibold text-primary-hrms bg-white border-0 cursor-pointer"
        onClick={handleDownload}
      >
        <span>
          <i className="ri-download-line"></i> Download
        </span>
      </button>

      <button
        className="text-xs font-semibold text-primary-hrms bg-white border-0 cursor-pointer"
        onClick={handleView}
      >
        <span>
          <i className="ri-eye-line"></i> View
        </span>
      </button>

      <button
        className="text-xs font-semibold text-primary-hrms bg-white border-0 cursor-pointer"
        onClick={handleEdit}
      >
        <span>
          <i className="ri-edit-line"></i> Edit
        </span>
      </button>

      <button
        className="text-xs font-semibold text-primary-hrms bg-white border-0 cursor-pointer"
        onClick={handleDelete}
      >
        <span>
          <i className="ri-delete-bin-line"></i> Delete
        </span>
      </button>
    </div>
  );
};

export default EmployeeTableActions;